/*
 * Tickets' marks (Deleg8 polish, 3 Oct 2026): icons, status and priority marks, avatars, where, and time words.
 * Pure: React only, no st8n import, so Deleg8's own web app (deleg8/apps/web) can use this file as it is.
 * kit.jsx re-exports all of it for st8n's screens.
 */
export const cx = (...a) => a.filter(Boolean).join(' ')

const svg = (children, { fill = 'none', w = 1.8 } = {}) => function Icon(p) {
  return <svg viewBox="0 0 24 24" fill={fill} stroke="currentColor" strokeWidth={w} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...p}>{children}</svg>
}
export const Ic = {
  Back: svg(<path d="M15 5 8 12l7 7" />, { w: 2.2 }),
  Plus: svg(<path d="M12 5v14M5 12h14" />, { w: 2 }),
  Down: svg(<path d="m6 9 6 6 6-6" />, { w: 2 }),
  Chev: svg(<path d="m9 6 6 6-6 6" />, { w: 2 }),
  Check: svg(<path d="m5 12.5 4.5 4.5L19 7.5" />, { w: 2.2 }),
  Close: svg(<path d="M6 6l12 12M18 6 6 18" />, { w: 2.2 }),
  List: svg(<path d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01" />, { w: 2 }),
  Board: svg(<><rect x="3.5" y="4" width="5" height="16" rx="1.5" /><rect x="10" y="4" width="5" height="11" rx="1.5" /><rect x="16.5" y="4" width="4" height="7" rx="1.5" /></>),
  Pin: svg(<><path d="M12 21s-6.5-5.7-6.5-11A6.5 6.5 0 0 1 18.5 10c0 5.3-6.5 11-6.5 11z" /><circle cx="12" cy="10" r="2.3" /></>),
  Computer: svg(<><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></>),
  Folder: svg(<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />),
  Person: svg(<><circle cx="12" cy="8" r="3.5" /><path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" /></>),
  Share: svg(<><circle cx="18" cy="5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="19" r="2.5" /><path d="m8.2 10.8 7.6-4.4M8.2 13.2l7.6 4.4" /></>),
  Play: svg(<path d="M7 5v14l11-7z" />, { fill: 'currentColor', w: 1 }),
  Pause: svg(<><rect x="6.5" y="5" width="3.6" height="14" rx="1" /><rect x="13.9" y="5" width="3.6" height="14" rx="1" /></>, { fill: 'currentColor', w: 0 }),
  Stop: svg(<rect x="6" y="6" width="12" height="12" rx="2" />, { fill: 'currentColor', w: 0 }),
  Note: svg(<path d="M4 5h16v11H9l-5 4z" />),
  Branch: svg(<><circle cx="6" cy="5" r="2" /><circle cx="6" cy="19" r="2" /><circle cx="18" cy="8" r="2" /><path d="M6 7v10M18 10c0 4-6 3-11.5 7" /></>),
  Commit: svg(<><circle cx="12" cy="12" r="3.5" /><path d="M3 12h5.5M15.5 12H21" /></>),
  Plus2: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 8v8M8 12h8" /></>),
  Shield: svg(<path d="M12 3 5 6v6c0 4.4 3 7.6 7 9 4-1.4 7-4.6 7-9V6z" />),
  Alert: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 7.5v5M12 16h.01" /></>, { w: 2 }),
  Info: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 11v5.5M12 7.6h.01" /></>, { w: 2 }),
  Mic: svg(<><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" /></>, { w: 2 }),
  Ask: svg(<><path d="M4 5h16v11H9l-5 4z" /><path d="M10 9.2a2 2 0 1 1 2.6 1.9c-.4.2-.6.5-.6.9M12 13.6h.01" /></>, { w: 2 }),
  Chart: svg(<path d="M4 20V10M10 20V4M16 20v-7M21 20H3" />, { w: 2 }),
  Tag: svg(<><path d="M3 12V4h8l10 10-8 8z" /><circle cx="7.5" cy="8" r="1.3" /></>),
  Bolt: svg(<path d="M13 2 4 14h7l-1 8 9-12h-7z" />),
  Inbox: svg(<><path d="M3 13h5l1.5 3h5L16 13h5" /><path d="M5 5h14l2 8v6H3v-6z" /></>),
  Edit: svg(<path d="M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4" />),
  Session: svg(<><rect x="3" y="4" width="18" height="16" rx="2.5" /><path d="m7 9 3 3-3 3M12.5 15H17" /></>),
}

/** Linear-style status marks: an empty ring, a quarter, a half, a filled check, a struck ring. */
export function StatusIcon({ status, className = 'tk-st' }) {
  const c = { open: 'var(--line-3)', claimed: 'var(--warn)', working: 'var(--warn)', blocked: 'var(--bad)', done: 'var(--accent)', cancelled: 'var(--line-3)' }[status] || 'var(--line-3)'
  const ring = <circle cx="8" cy="8" r="6.25" fill="none" stroke={c} strokeWidth="1.5" strokeDasharray={status === 'open' ? '2.2 1.9' : undefined} />
  return (
    <svg viewBox="0 0 16 16" className={className} role="img" aria-label={status}>
      {status === 'done' ? (<><circle cx="8" cy="8" r="7" fill={c} /><path d="m5 8.2 2 2 4-4.2" fill="none" stroke="var(--bg-2)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></>)
        : status === 'blocked' ? (<><circle cx="8" cy="8" r="7" fill={c} /><path d="M8 4.6v4M8 11.2h.01" stroke="var(--bg-2)" strokeWidth="1.7" strokeLinecap="round" /></>)
        : status === 'cancelled' ? (<><circle cx="8" cy="8" r="7" fill={c} /><path d="m5.7 5.7 4.6 4.6M10.3 5.7l-4.6 4.6" stroke="var(--bg-2)" strokeWidth="1.5" strokeLinecap="round" /></>)
        : (<>{ring}{status === 'claimed' ? <path d="M8 8V3.6A4.4 4.4 0 0 1 12.4 8z" fill={c} /> : null}{status === 'working' ? <path d="M8 3.6a4.4 4.4 0 0 1 0 8.8z" fill={c} /> : null}</>)}
    </svg>
  )
}

/** Priority 1..4: a red square with ! for urgent, else one to three bars. */
export function PriorityIcon({ p, className = 'tk-pr' }) {
  if (p === 1) return <svg viewBox="0 0 16 16" className={className} data-p="urgent" role="img" aria-label="Urgent"><rect x="1.5" y="1.5" width="13" height="13" rx="3.2" fill="currentColor" /><path d="M8 4.5v4.2M8 11.2h.01" stroke="var(--bg-2)" strokeWidth="1.8" strokeLinecap="round" /></svg>
  const n = { 2: 3, 3: 2, 4: 1 }[p] || 0
  return (
    <svg viewBox="0 0 16 16" className={className} role="img" aria-label={{ 2: 'High', 3: 'Normal', 4: 'Low' }[p] || 'No priority'}>
      {[0, 1, 2].map((i) => <rect key={i} x={2 + i * 4.6} y={10 - i * 3.2} width="2.8" height={4 + i * 3.2} rx="1" fill="currentColor" opacity={i < n ? 1 : 0.25} />)}
    </svg>
  )
}

export const hueOf = (s) => [...String(s || '')].reduce((h, c) => (h * 31 + c.charCodeAt(0)) % 360, 7)
export const nameOf = (p) => p?.name || p?.email || (p?.id === 'owner' ? 'Owner' : 'Team member')
export const initials = (name) => String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('')
export function Avatar({ person, large, title }) {
  if (!person) return null
  return <span className={cx('tk-av', large && 'tk-av-lg')} style={{ '--h': hueOf(person.id || person.name) }} title={title || nameOf(person)}>{initials(nameOf(person))}</span>
}
/** The words a mark's tooltip uses; Deleg8 without st8n says "Anyone" and a person's name (no sessions). */
export const assigneeWords = { any: 'Any free session', person: (name) => `${name}’s sessions` }
/** Who a ticket is assigned to: any (a dashed ring), a session (a small square) or a person (their initials). */
export function AssigneeMark({ assignee, sessions = [], people = [] }) {
  if (!assignee || assignee === 'any') return <span className="tk-av tk-av-any" title={assigneeWords.any}><Ic.Bolt /></span>
  if (assignee.startsWith('person:')) {
    const p = people.find((x) => x.id === assignee.slice(7)) || { id: assignee, name: '?' }
    return <Avatar person={p} title={assigneeWords.person(p.name)} />
  }
  const s = sessions.find((x) => x.id === assignee.slice(8))
  return <span className="tk-av tk-av-session" title={s ? `${s.name} on ${s.machine}` : 'A session'}>{(s?.name || '?')[0].toUpperCase()}</span>
}

export const Label = ({ l }) => <span className="tk-label" style={{ '--h': hueOf(l) }}>{l}</span>

export const shortPath = (p) => (p ? p.replace(/^\/(?:home|Users)\/[^/]+/, '~') : p)
export function whereText(where) {
  if (!where || (!where.machine && !where.folder)) return 'Anywhere'
  const m = where.machine?.startsWith('@') ? where.machine.split('/').slice(1).join('/') : where.machine
  return [m, shortPath(where.folder)].filter(Boolean).join(' · ')
}
/** `anywhere={false}`: say nothing when it may be done anywhere (a standalone Deleg8 has no computers to name). */
export const Where = ({ where, anywhere = true }) => (!anywhere && !where?.machine && !where?.folder ? null :
  <span className="tk-where">{where?.folder ? <Ic.Folder /> : where?.machine ? <Ic.Computer /> : <Ic.Pin />}<span>{whereText(where)}</span></span>
)

export function ago(t) {
  const s = Math.max(0, Math.round((Date.now() - t) / 1000))
  if (s < 45) return 'now'
  if (s < 3600) return `${Math.round(s / 60)}m`
  if (s < 86400) return `${Math.round(s / 3600)}h`
  return `${Math.round(s / 86400)}d`
}
/** "5m ago", or "just now". */
export const agoText = (t) => { const a = ago(t); return a === 'now' ? 'just now' : `${a} ago` }
export const clock = (t) => new Date(t).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
